/**
 * Identities used throughout the simulation. Engine-free and serialisable,
 * because the same values travel over the network later (Phase 10+).
 */
export const PLAYER_IDS = ['p1', 'p2', 'p3', 'p4'] as const;
export type PlayerId = (typeof PLAYER_IDS)[number];

/** Who owns an entity. Players own colonies; the infected and neutral world own the rest. */
export type OwnerId = PlayerId | 'infected' | 'neutral';

export function isPlayerId(v: unknown): v is PlayerId {
  return typeof v === 'string' && (PLAYER_IDS as readonly string[]).includes(v);
}
